import WorkspacePremiumIcon from "@mui/icons-material/EmojiEvents";
import LearningModulePage from "../../components/LearningModulePage";

function IeltsPage() {
  return (
    <LearningModulePage
      title="IELTS"
      eyebrow="Exam module"
      description="A future IELTS track for writing practice, band descriptors, speaking prompts, and reading/listening drills."
      icon={WorkspacePremiumIcon}
      color="#1f9b45"
      bg="#e8f9ed"
      items={[
        "Writing task practice",
        "Speaking prompt bank",
        "Reading and listening drills",
      ]}
    />
  );
}

export default IeltsPage;
